import { ACCOUNTS, BASE_URL, BULK_UPDATE_CREATE, COUNTRIES, EXPORT, FILTERS, IKA_MAPPING, INPUT_FORMS, MFA, USERS } from "../../constant/apiEndpoints";
import * as constants from "../../pages/MappingFile/IKAMap/constants";
import { ICountry } from "../../reducer/General/_interfaces";
import { IIKAMap, IIKAMapForSave, IIKAMapFromTable, ISelectedFilters } from "../../reducer/mappingFiles/_interfaces";
import { SET_IKA_ERROR, SET_IKA_MAP_COUNTRIES, SET_IKA_MAP_COUNTRIES_LOADING, SET_IKA_MAP_DATA, SET_IKA_MAP_DATA_LOADING, SET_INPUT_SUGGESTIONS } from "../../reducer/mappingFiles/constants"
import { IAPIReturn } from "../../services/_interfaces";
import APIService from "../../services/APIService";

export const setIKAMapData = (payload:IIKAMap[]) => ({ type: SET_IKA_MAP_DATA, payload })
export const setError = (payload:string) => ({ type: SET_IKA_ERROR, payload })

export const loadCountries = (formId:string) => async (dispatch:any) => {
    dispatch({ type: SET_IKA_MAP_COUNTRIES_LOADING, payload: true });

    const url = BASE_URL + ACCOUNTS + USERS + COUNTRIES + `?form_id=${formId}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in user countrylist API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_COUNTRIES_LOADING, payload: false });
    } else {
        const transformedData = response.results.map(({ id, title }:{id:string, title:string}) => ({
            label: title,
            value: id,
            id,
            title
        }));
        dispatch({type: SET_IKA_MAP_COUNTRIES, payload: transformedData});
    }
}

export const loadData = (filters:ISelectedFilters, selected_form:string) => async (dispatch:any) => {
    dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: true });
    
    const {
        buyng_group_cust_name,
        cust_planning_level,
        cust_planning_level_name,
        gkc,
        selected_country,
    } = filters

    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING
        + `?selected_form=${selected_form}&selected_country=${selected_country?.id || ''}&cust_planning_level=${encodeURIComponent(cust_planning_level?.id || '')}&cust_planning_level_name=${encodeURIComponent(cust_planning_level_name?.id || '')}&gkc=${encodeURIComponent(gkc?.id || '')}&buyng_group_cust_name=${encodeURIComponent(buyng_group_cust_name?.id || '')}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in IKA Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: false });
    } else {
        dispatch(setIKAMapData(response.results));
    }
}

export const deleteItems = (comment:string, ids:number[], selected_form:string, filters:ISelectedFilters) => async (dispatch:any) => {
    dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: true });
    
    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING;
    const response:IAPIReturn = await new APIService().delete(url, {comment, ids, selected_form});

    if (response.error) {
        console.log("error in IKA Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: false });
    } else {
        dispatch(loadData(filters, selected_form));
    }
}

export const saveItem = (item:IIKAMapForSave, selected_form:string) => async (dispatch:any) => {
    dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: true });
    console.log(item);
    
    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING + `?selected_form=${selected_form}`;
    let response:IAPIReturn;
    if (item.id) {
        response = await new APIService().put(url, { item, selected_form });
    } else {
        response = await new APIService().post(url, { item, selected_form });

    }
    
    if (response.error) {
        console.log("error in IKA Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: false });
    } else {
        dispatch(loadData(constants.INITIAL_FILTERS, selected_form));
    }
}

export const massUpload = async (data:IIKAMapFromTable[], selected_form:string) => {
    const dataMap = data.map((item) => ({
        buyng_group_cust_name: item['Buying Group or Customer Name'],
        country: item['Country'],
        cust_planning_level: item['Cust. Planning Level'],
        cust_planning_level_name: item['Cust. Planning Level Name'],
        gkc: item['GKC'],
        reason: item['Comment'],
    }))

    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING + BULK_UPDATE_CREATE + `?selected_form=${selected_form}`;
    try {
        const response:IAPIReturn = await new APIService().post(url, { data: dataMap, selected_form });
        return response;
    } catch (error) {
        throw new Error('Error') 
    }

}

export const exportData = () => async (dispatch:any) => {
    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING + EXPORT + `?selected_form=formmap`

    fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token') || '').access}`,
            })
        }).then(response =>
            response.blob().then(blob => {
                const today = new Date()
                const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "dim_company_" + date + "_" + time + ".csv";
                a.click();
            })
        );
}

export const getFilters = (selected_form:string) => async (dispatch:any) => {
    const url = BASE_URL + INPUT_FORMS + MFA + IKA_MAPPING + FILTERS + `?selected_form=${selected_form}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in IKA Mapping API", response.results.message);
        dispatch(setError(response.results.message));
        dispatch({ type: SET_IKA_MAP_DATA_LOADING, payload: false });
    } else {
        dispatch({type: SET_INPUT_SUGGESTIONS, payload: response.results});
    }
}